import {Viewer, Worker} from '@react-pdf-viewer/core';
import {defaultLayoutPlugin} from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import {useService} from '../../../../infrastructure/service/service';
import {observer} from 'mobx-react-lite';
import Box from '@mui/material/Box';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import React, {useEffect, useState} from 'react';
import {Typography} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import {PageOption} from '../../../../entity/enums/page-option';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import {Document} from '../../../../entity/resource/document';
import {Section} from '../../../../entity/resource/section';
import {DocumentViewerProps} from '../../../../entity/props/widget/document-viewer-props';

import '../../../../assets/css/widget/document-viewer.css';
import '../../../../assets/css/style.css';

const DocumentViewer = (props: DocumentViewerProps): JSX.Element => {
  const {documentService, titleService, sectionService} = useService();

  const [document, setDocument] = useState<Document>();
  const [documentSection, setDocumentSection] = useState<Section>();
  const [disablePrev, setDisablePrev] = useState<boolean>(false);
  const [disableNext, setDisableNext] = useState<boolean>(false);

  useEffect(() => {
    const document = documentService.getDocument();
    setDocument(document);

    const documentSection = documentService.geDocumentSection();
    setDocumentSection(documentSection);

    if (documentSection && document) {
      const currentIndex = documentSection.documents.indexOf(document);
      setDisablePrev(currentIndex === 0);
      setDisableNext(currentIndex === documentSection.documents.length - 1);
    }

  }, [documentService.getDocument(), documentService.geDocumentSection()]);

  const handleBackToDocuments = (): void => {
    titleService.setPageOption(PageOption.DOCUMENTS);
    sectionService.setViewDocument(false);
    documentService.setDocument(undefined);
  }

  const handleViewPreviousDocument = (): void => {
    if (document && documentSection) {
      const currentIndex = documentSection.documents.indexOf(document);
      documentService.setDocument(documentSection.documents[currentIndex - 1]);
    }
  }

  const handleViewNextDocument = (): void => {
    if (document && documentSection) {
      const currentIndex = documentSection.documents.indexOf(document);
      documentService.setDocument(documentSection.documents[currentIndex + 1]);
    }
  }

  return (
    <Box>
      <Box className={'view-document-container'}>
        <KeyboardArrowLeftIcon className={'document-back-icon'} onClick={handleBackToDocuments}/>
        <Box className={'document-box'}>
          {
            !props.tab &&
              <KeyboardDoubleArrowLeftIcon className={`document-action prev ${disablePrev ? 'opacity' : ''}`} onClick={!disablePrev ? handleViewPreviousDocument : undefined}/>
          }
          <PictureAsPdfIcon className="zitles-icon" />
          <Typography className={'view-document-name'}>{document?.name ?? ''}</Typography>
          {
            !props.tab &&
              <KeyboardDoubleArrowRightIcon className={`document-action next ${disableNext ? 'opacity' : ''}`} onClick={!disableNext ? handleViewNextDocument : undefined}/>
          }
        </Box>
      </Box>
      <Box className={'pdf-container'}>
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.7.107/build/pdf.worker.min.js">
          <Viewer fileUrl={document?.url ?? ''} plugins={[defaultLayoutPlugin()]} />
        </Worker>
      </Box>
    </Box>
  );
}

export default observer(DocumentViewer);
